'use client'

import { LazyMotion } from 'motion/react'
import type { ReactNode } from 'react'

// --------------------------------------------------------------------------------------------- //

type Props = {
  children: ReactNode
}

const loadFeaturesAsync = async () => import('./features').then(res => res.default)

export function MotionLazy({ children }: Props) {
  return (
    <LazyMotion strict features={loadFeaturesAsync}>
      {children}
    </LazyMotion>
  )
}
